module.exports = __webpack_public_path__ + "static/fonts/PorscheNextArabicTT-Bold.aa28fccd.ttf";